import { RecurrentSchedule, Reservation } from '@raysee/schema';
import dayjs from 'dayjs';
import { useState } from 'react';
import { Button } from 'rsuite';
import { DeleteRecurrentScheduleModal } from '../modals/DeleteRecurrentScheduleModal';
import { EditRecurrentScheduleModal } from '../modals/EditRecurrentScheduleModal';

type Props = {
  schedules: RecurrentSchedule[];
  reservations: Reservation[];
  onEditRecurrentSchedule: (
    values: Pick<RecurrentSchedule, 'startDate' | 'endDate' | 'dows'> & {
      startTime: number;
      endTime: number;
      hasExpiration: boolean;
    },
  ) => Promise<void>;
};

export const RecurrentScheduleList = (props: Props) => {
  const [scheduleToBeDeleted, setScheduleToBeDeleted] = useState<RecurrentSchedule | undefined>(
    undefined,
  );
  const [scheduleToBeChanged, setScheduleToBeChanged] = useState<RecurrentSchedule | undefined>(
    undefined,
  );

  const confirmDelete = (schedule: RecurrentSchedule) => {
    setScheduleToBeDeleted(schedule);
  };

  const confirmChange = (schedule: RecurrentSchedule) => {
    setScheduleToBeChanged(schedule);
  };

  const recurrentScheduleList =
    props.schedules.length > 0 ? (
      <ul>
        {props.schedules.map((schedule) => (
          <li key={schedule.id}>
            <span className="mx-1">
              {dayjs(schedule.startDate).format('YYYY/MM/DD')}〜
              {schedule.endDate ? dayjs(schedule.endDate).format('YYYY/MM/DD') : ''}
            </span>
            <span className="mx-1">
              {dayjs(schedule.startTime).format('HH:mm')}-
              {!dayjs(schedule.startTime).isSame(schedule.endTime, 'day') && '翌'}
              {dayjs(schedule.endTime).format('HH:mm')}
            </span>
            <span className="mx-1">{schedule.dows.join(',')}</span>
            <Button appearance="link" color="red" onClick={() => confirmDelete(schedule)}>
              削除
            </Button>
            <Button appearance="link" onClick={() => confirmChange(schedule)}>
              変更する
            </Button>
          </li>
        ))}
      </ul>
    ) : (
      <div>該当する設定はありません</div>
    );
  return (
    <>
      {recurrentScheduleList}
      {scheduleToBeDeleted && (
        <DeleteRecurrentScheduleModal
          recurrentSchedule={scheduleToBeDeleted}
          reservations={props.reservations ?? []}
          isOpen={!!scheduleToBeDeleted}
          onClose={() => setScheduleToBeDeleted(undefined)}
        />
      )}
      {scheduleToBeChanged && (
        <EditRecurrentScheduleModal
          recurrentSchedule={scheduleToBeChanged}
          reservations={props.reservations ?? []}
          isOpen={!!scheduleToBeChanged}
          onClose={() => setScheduleToBeChanged(undefined)}
          onEdit={props.onEditRecurrentSchedule}
        />
      )}
    </>
  );
};
